// extracted by mini-css-extract-plugin
export default {"root":"OrdersList_root__EAi0M","root_nothing":"OrdersList_root_nothing__NvhJu","window":"OrdersList_window__PFbeE"};